var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.56806 7.10857C0.955409 7.10857 0.459489 6.61265 0.459489 6C0.459489 5.38735 0.955409 4.89143 1.56806 4.89143L10.4319 4.89299C11.0438 4.89378 11.5405 5.39048 11.5405 6.00157C11.5405 6.61422 11.0446 7.11014 10.4319 7.11014L1.56806 7.10857Z",
    fill: "#00ABE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1079 1.569C7.10711 0.95707 6.61115 0.461102 5.99922 0.460318C5.3865 0.460318 4.89054 0.956286 4.89054 1.569L4.8921 10.4337C4.89289 11.0457 5.38964 11.5424 6.00078 11.5424C6.6135 11.5424 7.10946 11.0465 7.10946 10.4337L7.1079 1.569Z",
    fill: "#00ABE8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.46bbeeb00b493247100e295f6762fa89.svg";
export { ForwardRef as ReactComponent };